import PropTypes from 'prop-types';

const SeoText = ({ className, text }) => {
  return (
    <div className={className}>
      <div
        dangerouslySetInnerHTML={{
          __html: text
        }}
      />
    </div>
  );
};

SeoText.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired
};

SeoText.defaultProps = {
  className: ''
};

export default SeoText;
